import $http from '@/api/index'
// 添加、编辑
export function AddorUpdateEmergencyCompanyInfo(params) {
  let options = {
    method: 'POST',
    url: 'emergencybasedata/AddorUpdateEmergencyCompanyInfo',
    requestType: 11,
    isJsonData: true
  }
  return $http(options, params);
}
// 列表
export function GetEmergencyCompanyExSearchResultCount(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetNewEmergencyCompanyExSearchResultCount',
    requestType: 11
  }
  return $http(options, params);
}
// 删除
export function DeleteCompanyExInfoById(params) {
  let options = {
    method: 'POST',
    url: 'emergencybasedata/DeleteCompanyExInfoById',
    requestType: 11,
    isParams: true
  }
  return $http(options, params);
}
// 更改机构状态启用停用
export function ChangeCompanyExStateById(params) {
  let options = {
    method: 'POST',
    url: 'emergencybasedata/ChangeCompanyExStateById',
    requestType: 11,
    isParams: true
  }
  return $http(options, params);
}
// 根据父code获取机构类型
export function GetAllCompanyTypeByParentId(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetAllCompanyTypeByParentId',
    requestType: 11
  }
  return $http(options, params);
}
// 根据父code获取诊疗项目
export function GetAllStandardTreatMentListByParentId(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetAllStandardTreatMentListByParentId',
    requestType: 11
  }
  return $http(options, params);
}
// 根据code获取父级诊疗项目
export function GetStandTreatMentByCode(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetStandTreatMentByCode',
    requestType: 11
  }
  return $http(options, params);
}
// 根据code获取父级机构类别
export function GetCompanyTypeByCode(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetCompanyTypeByCode',
    requestType: 11
  }
  return $http(options, params);
}

// 机构级别，机构等次, 公务员职称， 医师职称， 护士职称
export function GetDictInfoListByType(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetDictInfoListByType',
    requestType: 11
  }
  return $http(options, params);
}
// GetAreaCommonAndCustomListByParentId
// 通过parentId获取第三级区域数据
export function GetAreaCommonAndCustomListByParentId(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetAreaCommonAndCustomListByParentId',
    requestType: 11
  }
  return $http(options, params);
}
// 通过当前areaid获取父集区域信息（自定义）
export function GetVmAreaCommonAndCustomById(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetVmAreaCommonAndCustomById',
    requestType: 11
  }
  return $http(options, params);
}
// 通过当前areaid获取父集区域信息（国标）
export function GetAreaDivisionById(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetAreaDivisionById',
    requestType: 11
  }
  return $http(options, params);
}
// 校验机构代码是否重复
export function IsExistCompanyCode(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/IsExistCompanyCode',
    requestType: 11
  }
  return $http(options, params);
}